import React from 'react';
import { Grid } from '@mui/material';
import appConfig from '../../../config/appConfig';
import LoginForm from '../components/LoginForm';
import { useLocation } from 'react-router-dom';
import OTPVerificationForm from '../../../components/OTPVerificationForm';
import { resolveSafePostAuthPath } from '../../../utils/authToken';
import { readPendingOrgMfaContext } from '../../../utils/authSession';
import { HOME_ROUTE } from '../../../constants/defaults';
import { authPageGridSx } from '../../../styles/authPageLayout';

const LoginPage = () => {
  const location = useLocation();
  const state = location.state;
  const pendingOrgMfa = readPendingOrgMfaContext();
  const redirectTo = resolveSafePostAuthPath(state?.redirectTo || state?.from || HOME_ROUTE);
  const showOrgMfaOtp =
    state?.stage === 'otp_required' || (pendingOrgMfa?.organizationId && state?.stage !== 'verification');

  const getComponent = () => {
    if (state?.stage === 'verification') {
      return <OTPVerificationForm email={state.email} redirectTo={redirectTo} />;
    }

    if (showOrgMfaOtp) {
      return (
        <OTPVerificationForm
          email={state?.email || pendingOrgMfa?.email}
          isLogin={true}
          orgMfa={state?.orgMfa ?? Boolean(pendingOrgMfa?.organizationId)}
          organizationId={state?.organizationId || pendingOrgMfa?.organizationId}
          redirectTo={redirectTo}
        />
      );
    }

    return <LoginForm redirectTo={redirectTo} />;
  };

  return (
    <Grid container sx={authPageGridSx}>
      <Grid
        size={{ xs: 0, lg: 7, xl: 6 }}
        sx={{
          display: { sm: 'none', lg: 'flex' },
        }}
      >
        <img
          src={appConfig.brandBackgroundImagePath}
          alt="signup background"
          width="100%"
          style={{ display: 'flex' }}
        />
      </Grid>
      <Grid size={{ xs: 1, sm: 2, md: 3, lg: 1, xl: 2 }} />
      <Grid size={{ xs: 10, sm: 8, md: 6, lg: 3, xl: 3 }}>{getComponent()}</Grid>
      <Grid size={{ xs: 1, sm: 2, md: 3, lg: 1, xl: 1 }} />
    </Grid>
  );
};

export default LoginPage;
